module.exports = __webpack_public_path__ + "img/entj.448ded0b.png";